const EscapeToCancelMixin = {
  mounted() {
    this._handleEscape = (e) => {
      if (e.keyCode == 27) {
        if(typeof this.cancel === "function") {
          this.cancel()
        }
        else {
          console.error("cancel method not defined for escape to cancel mixin")
        }
      }
    }
    window.addEventListener("keyup", this._handleEscape)
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this._handleEscape)
  }
}

export default EscapeToCancelMixin